export interface LoadingType {
    loading: boolean;
}

export enum LoadingActionTypes {
    LOADING = '@@loading/LOADING',
    LOADED = '@@loading/LOADED'
}